import axios from 'axios';
import router from "../router";
import { Message } from 'element-ui'

axios.defaults.timeout = 20000;
// axios.defaults.baseURL ="http://192.168.1.58:8810"; //填写域名
// axios.defaults.baseURL="http://19.50.71.57:8666";//珠海服务器
// axios.defaults.baseURL="http://113.106.103.85:8663";
axios.defaults.baseURL ="https://apartment.cloudelock.com"; //填写域名
// axios.defaults.baseURL ="https://condo.cloudelock.com"
axios.defaults.withCredentials = true;//统一设置带header.cookies

//http request 拦截器
axios.interceptors.request.use(
  config => {
    var i18n=localStorage.getItem("language");
    if("/customer/security/checkLogin"==config.url){
      config.data =config.data;
      config.headers = {
        'Content-Type':'application/x-www-form-urlencoded',
        "i18n-language": i18n=="en"?"en_US":"zh_CN"
      }
      //直接参数传值配置
      // config.data = config.data;
      // config.headers = {
      //   "Content-Type":'multipart/form-data'
      // } 
    }else{
      // config.data = window.JSON.stringify(config.data);
      // config.headers = {
      //   'Content-Type':'application/x-www-form-urlencoded'
      // }
      //直接参数传值配置
      config.data = config.data;
      config.headers = {
        "Content-Type":'multipart/form-data',
        "i18n-language":i18n=="en"?"en_US":"zh_CN"
      } 
    }
   
    return config;
  },
  error => {
    return window.Promise.reject(err);
  }
);

//响应拦截器即异常处理
axios.interceptors.response.use(response => {
    return response
}, err => {
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
            console.log('错误请求')
          break;
        case 401:
            console.log('未授权，请重新登录')
          break;
        case 403:
          console.log('拒绝访问')
          break;
        case 404:
          console.log('请求错误,未找到该资源')
          break;
        case 405:
          console.log('请求方法未允许')
          break;
        case 408:
          console.log('请求超时')
          break;
        case 500:
          console.log('服务器端出错')
          break;
        case 501:
          console.log('网络未实现')
          break;
        case 502:
          console.log('网络错误')
          break;
        case 503:
          console.log('服务不可用')
          break;
        case 504:
          console.log('网络超时')
          break;
        case 505:
          console.log('http版本不支持该请求')
          break;
        default:
          console.log(`连接错误${err.response.status}`)
      }
    } else {
      console.log('连接到服务器失败')
    }
    return window.Promise.resolve(err.response)
})


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function fetch(url,params={}){
  return new window.Promise((resolve,reject) => {
    axios.get(url,{
      params:params
    })
    .then(response => {
      resolve(response.data);
    })
    .catch(err => {
      reject(err)
    })
  })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

 export function post(url,data = {}){
   return new window.Promise((resolve,reject) => {
     axios.post(url,data)
          .then(response => {
            console.log(response.data);
            switch(response.data.code){
              case -3:
              case -4:
              case -5:
              case -7:
                  Message({
                    type: 'error',
                    message: response.data.message+"错误码："+response.data.code
                  });   
                  sessionStorage.removeItem("user");
                  router.push("/");
                 break;
               default:
                resolve(response.data);
                 break;  
            }
           
          },err => {
            Message({
              type: 'error',
              message: response.data.message
            });
            sessionStorage.removeItem("user");
            router.push("/");
            // reject(err) 
          })
   })
 }

 /**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url,data = {}){
  return new window.Promise((resolve,reject) => {
    axios.patch(url,data)
         .then(response => {
           resolve(response.data);
         },err => {
           reject(err)
         })
  })
}

 /**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url,data = {}){
  return new window.Promise((resolve,reject) => {
    axios.put(url,data)
         .then(response => {
           resolve(response.data);
         },err => {
           reject(err)
         })
  })
}

/**
* 下面是获取数据的接口
*/
/** 
* 测试接口
* 名称：exam
* 参数：paramObj/null
* 方式：fetch/post/patch/put
*/
export const server = {
    //暴露封装post
    exam: function(url,paramObj){
        return post(url,paramObj);
    },
    get:function(){
      return axios.get("http://192.168.1.58:8833/openapi/v1/systemInfo?roomId=21121473fd204c2356475984d86b844326ecde&operationType=3", {
        //params: data, //附带参数
        withCredentials: true, // 跨域请求时发送Cookie
        // headers: {'appId':'99ead75975224842b21539e415c6f7aa'} //设置header信息
      }).then((res) => { 
        //then 成功
        console.log("获取到信息")
      }).catch((err) => {
        //catch 失败
        console.log("获取信息失败")
      });
      
    }

}


// WEBPACK FOOTER //
// ./src/utils/http-service.js